import { t } from '../i18n'

// "Out of stock" / "Only 3 left" label for storefront product cards and the
// product page. Renders nothing while an item is comfortably in stock.
export default function StockBadge({ item, className = '' }) {
  if (!item) return null
  if (item.in_stock === false) return <span className={`stock-badge is-out ${className}`}>{t('Out of stock')}</span>
  if (item.stock_left) return <span className={`stock-badge is-low ${className}`}>{t('Only {count} left', { count: item.stock_left })}</span>
  return null
}
